package fr.manyverse.app.presentation.components.modules.whiteboard
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.model.WhiteboardColor

@Composable
fun WhiteboardPlayerOverlay(
    isVisible: Boolean,
    strokes: List<WhiteboardAction.Stroke>,
    showGrid: Boolean,
    onMinimize: () -> Unit,
    modifier: Modifier = Modifier
) {
    WhiteboardGmOverlay(
        isVisible = isVisible,
        isGM = false,
        strokes = strokes,
        showGrid = showGrid,
        selectedColor = WhiteboardColor.BLACK,
        strokeWidth = 4f,
        selectedTool = WhiteboardTool.PEN,
        onStrokeComplete = {},
        onColorSelect = {},
        onToolSelect = {},
        onToggleGrid = {},
        onClearAll = {},
        onMinimize = onMinimize,
        onCloseForAll = null,
        modifier = modifier
    )
}